import axios from 'axios';
import { APP_SETTINGS } from '../../config';

export function signUp(data) {
    return axios.post(APP_SETTINGS.API_PATH.SIGNUP.singUp, data);
}
export function accountExist(data) {
    return axios.post(APP_SETTINGS.API_PATH.SIGNUP.AccountExist, data);
}
export function resendNewOTP(data) {
    return axios.post(APP_SETTINGS.API_PATH.SIGNUP.ResendOTP, data);
}
export function ConfirmOTP(data) {
    return axios.post(APP_SETTINGS.API_PATH.SIGNUP.ConfirmOTP, data);
}
export function CompleteProfile(data) {
    return axios.post(APP_SETTINGS.API_PATH.SIGNUP.CompleteProfile, data);
}


// export function getUserSelectListByRoleApi(token) {
//     return axios.get(APP_SETTINGS.API_PATH.USERS.getEmployeesSelectListByRole, {
//         headers: {
//             "Authorization": "Bearer " + token
//         }
//     })
// }